import { useApiDocumentsV1DocumentsRetrieve } from 'api';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CenteredLoader, Sidebar, useBreakpoint } from 'ui';

import { DocumentList } from '../../components';
import { DocumentDetails } from '../../components/DocumentDetails/DocumentDetails';
import { NoDocument } from '../../components/NoDocument/NoDocument';
import { DocumentProvider } from '../../context/DocumentContext';

export const DocumentPage = () => {
  const { id: idParam } = useParams();
  const {
    data: document,
    isLoading,
    error,
  } = useApiDocumentsV1DocumentsRetrieve(Number(idParam), {
    query: {
      enabled: Boolean(idParam),
    },
  });
  const { isMobile } = useBreakpoint();
  const [isSidebarOpen, setIsSidebarOpen] = useState(isMobile ? false : true);
  if (isLoading) {
    return <CenteredLoader />;
  }

  if (!document) {
    return <NoDocument />;
  }

  return (
    <DocumentProvider document={document} isLoading={isLoading} error={error}>
      <Sidebar.Container isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen((open) => !open)}>
        <DocumentDetails />
        <Sidebar isOpen={isSidebarOpen}>
          <DocumentList contextObjectId={document.context_object_id} />
        </Sidebar>
      </Sidebar.Container>
    </DocumentProvider>
  );
};
